import { Component, CustomElement } from "../../core/CustomElement";
import {
  LeaderboardUser,
  LeaderboardUserLevel,
} from "../../core/types/Leaderboard";
import { capitalizeFirstLetter } from "../../core/utilities";

export interface ICCCLeaderboardPanelState {
  level: LeaderboardUserLevel;
  icon: string;
  maxHeight: number;
  items: LeaderboardUser[];
}

@Component("ccc-leaderboard-panel", {
  template: require("./template.html").default,
  style: require("./style.scss").default,
  observedAttributes: ["level", "icon", "max-height"],
})
export default class CCCLeaderboardPanel extends CustomElement {
  state: ICCCLeaderboardPanelState = {
    level: LeaderboardUserLevel.blue_ribbon,
    icon: "",
    maxHeight: 0,
    items: [],
  };

  private itemTmpl =
    '<div class="icon"><img src="{{avatar}}" title="{{name}}" /></div><div class="name"><a href="{{link}}">{{name}}</a></br><a class="company">{{company}}</a></div>';

  attributeChangedCallback(
    attr: string,
    _oldValue: null | string,
    newValue: string
  ): void {
    if (Object.hasOwnProperty.call(this.state, attr)) {
      this.setKeyState(attr, newValue);
    } else if (attr === "max-height") {
      this.setKeyState(attr, parseInt(newValue));
    }
  }

  watchLevel(): void {
    const title =
      this.state.level.split("_").map(capitalizeFirstLetter).join(" ") +
      " Level";
    const $title = this.shadowDom.querySelector(".title");
    $title.classList.add("level-" + this.state.level.replace("_", "-"));
    $title.querySelector(".text").innerHTML = title;
  }

  watchItems(): void {
    if (this.state.items.length > 0) {
      this.shadowDom.querySelector(".list").innerHTML = "";
      this.state.items.forEach(this.addItemToList.bind(this));
    }
  }

  addItemToList(item: LeaderboardUser): void {
    const $list = this.shadowDom.querySelector(".list");
    const tmpl = this.itemTmpl
      .replace(/{{link}}/gi, item.link)
      .replace(/{{avatar}}/gi, item.avatar)
      .replace(/{{name}}/gi, item.name)
      .replace(/{{company}}/gi, item.company);
    const $cnt = document.createElement("div");
    $cnt.classList.add("item");
    $cnt.innerHTML = tmpl;
    $list.append($cnt);
  }
}
